"use client";

import { getMissionActionsDetail } from "@/actions/action";
import { actionQueryKeys } from "@/constants/queryKeys/actionQueryKeys";
import { useQuery } from "@tanstack/react-query";

export const useReadActionsDetail = (missionId: string) => {
  return useQuery({
    queryKey: actionQueryKeys.actions({ missionId }),
    queryFn: () => getMissionActionsDetail(missionId),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retry: 3,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export type UseReadActionsDetailReturn = ReturnType<typeof useReadActionsDetail>;
